import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteNotificationMessageTemplate(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteNotificationMessageTemplate = (
    notificationMessageTemplateId: string,
  ): Promise<AxiosResponse<null>> => {
    return client.delete(`notification-message-templates/${notificationMessageTemplateId}/`);
  };

  return useMutation(deleteNotificationMessageTemplate, {
    onSuccess: () => {
      queryClient.removeQueries(['notificationMessageTemplates']);
    },
  });
}
